import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';

import { Tags } from 'components/Settings/Components/Tags/components/tags';
import { settingsConfig } from 'components/Settings/settingsConfig';

export const TagsPage = () => {
    useFullStoryPageView({ pageName: settingsConfig.tags.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <BottomHeaderSection>
                    <ProgramTopHeader pageTitle={settingsConfig.tags.title} />
                </BottomHeaderSection>
            </HeaderWrapper>
            <MainContent>
                <Tags />
            </MainContent>
        </PageContainer>
    );
};
